import { pathOr } from 'ramda';
import type { HeaderBodyImageWithLinkGallery } from '../models.generated';
import { useHeaderBodyImageWithLinkGalleryQuery } from '../queries/contentTypes/headerBodyImageWithLinkGallery.generated';
import { transformCtaWithUrlData } from './useCtaWithUrlData';
import type { HeaderBodyImageWithLinkItem } from './useHeaderBodyImageWithLinkData';
import { transformImageData } from './useImageData';

export const transformHeaderBodyImageWithLinkData = (
  headerBodyImageWithLinkItem: HeaderBodyImageWithLinkItem,
) => {
  const {
    key,
    eyebrow,
    header,
    body,
    image,
    link,
    linkRef,
  } = headerBodyImageWithLinkItem;

  const transformedImageData = image
    ? transformImageData({ data: { image } })
    : { image: null };

  return {
    key,
    // Prefer undefined over null
    eyebrow: eyebrow || undefined,
    header: header || `HeaderBodyImageWithLinkGallery: ${key}`,
    body: body || undefined,
    ...transformedImageData,
    link: link || '',
    // Prefer undefined over null
    linkRef: linkRef
      ? transformCtaWithUrlData({ data: { ctaWithUrl: linkRef } })
      : undefined,
  };
};

export const transformHeaderBodyImageWithLinkGalleryData = (
  response: object,
): HeaderBodyImageWithLinkItem[] => {
  const rawHeaderBodyImageWithLinkItems = pathOr(
    [],
    ['data', 'headerBodyImageWithLinkGallery', 'itemsCollection', 'items'],
    response,
  );

  const headerBodyImagesWithFallbacks: HeaderBodyImageWithLinkItem[] = rawHeaderBodyImageWithLinkItems
    .filter((item: HeaderBodyImageWithLinkItem) => !!item)
    .map(transformHeaderBodyImageWithLinkData);

  return headerBodyImagesWithFallbacks;
};

const useHeaderBodyImageWithLinkGalleryData = (
  id: HeaderBodyImageWithLinkGallery,
): HeaderBodyImageWithLinkItem[] => {
  const res = useHeaderBodyImageWithLinkGalleryQuery({
    variables: { id },
  });

  return transformHeaderBodyImageWithLinkGalleryData(res);
};

export default useHeaderBodyImageWithLinkGalleryData;
